import { useMemo } from "react";
import { createExtensionWithFirebase } from "logic/extensionWithFirebase";
import useFirestore from "./useFirestore";

/**
 * Hook to access the Firebase-based WhatsApp extension service
 * @returns The ExtensionWithFirebase instance
 */
const useExtensionWithFirebase = () => {
  const { myApiToken } = useFirestore();

  // Create the extension service instance only once when myApiToken changes
  const extensionService = useMemo(() => {
    if (!myApiToken) return null;
    return createExtensionWithFirebase(myApiToken);
  }, [myApiToken]);

  return extensionService;
};

export default useExtensionWithFirebase;
